<div class="placeholder-glow">
  @for (_ of [].constructor(rows); track $index) {
    <span class="placeholder" [ngClass]="['placeholder', 'col-' + width]"></span>
  }
</div>
